import { SUBSCRIPTION_STATUS, CARD_STYLE } from './constants';

// titleType: 'plan' = "Current plan 'Plan Name'", 'custom' = custom title text, 'planWithSubtitle' = plan name + subtitle
const STATUS_CONFIG = {
  [SUBSCRIPTION_STATUS.TRIALING]: {
    style: CARD_STYLE.TRIAL,
    titleType: 'plan',
    planSuffixKey: 'TRIAL_SUFFIX',
    infoLine: (t, sub) =>
      `${t('TRIAL_PERIOD')} · ${t('DAYS_REMAINING', { days: sub.trialDaysLeft ?? sub.trialDaysTotal })}`,
    showTrialEndDate: true,
    description: (t, sub) => t('TRIAL_DESCRIPTION', { days: sub.trialDaysTotal, balance: sub.balanceText }),
    action: { labelKey: 'UPGRADE_PLAN', variant: 'contained', handler: 'onUpgrade' },
    footer: 'trialWarning',
    sidebarWarning: null,
  },

  [SUBSCRIPTION_STATUS.ACTIVE]: {
    style: CARD_STYLE.DEFAULT,
    titleType: 'plan',
    infoLine: (t, sub) => {
      if (sub.scheduledChange) {
        return t(`SCHEDULED_${sub.scheduledChange.type}`, {
          date: sub.scheduledChange.formattedDate,
          plan: sub.scheduledChange.toPlanName || '',
        });
      }
      return sub.renewalInfo;
    },
    showTrialEndDate: false,
    description: (t, sub) => `${sub.price} ${sub.period}`,
    action: (sub) =>
      sub.scheduledChange?.type === 'CANCEL'
        ? { labelKey: 'RENEW_PLAN', variant: 'outlined', handler: 'onRenew' }
        : { labelKey: 'UPGRADE_PLAN', variant: 'outlined', handler: 'onUpgrade' },
    footer: 'cancelLink',
    sidebarWarning: null,
  },

  [SUBSCRIPTION_STATUS.CANCELED]: {
    style: CARD_STYLE.INACTIVE,
    titleType: 'custom',
    titleKey: 'STATUS_TITLE_CANCELED',
    infoLine: (t) => t('SUBSCRIPTION_CANCELED'),
    showTrialEndDate: false,
    description: (t) => t('STATUS_DESC_CANCELED'),
    action: { labelKey: 'CHOOSE_PLAN', variant: 'contained', handler: 'onUpgrade' },
    footer: null,
    sidebarWarning: 'SIDEBAR_WARNING_CANCELED',
    disableReplenish: true,
  },

  [SUBSCRIPTION_STATUS.ENDED]: {
    style: CARD_STYLE.INACTIVE,
    titleType: 'custom',
    titleKey: 'STATUS_TITLE_ENDED',
    infoLine: (t) => t('SUBSCRIPTION_ENDED'),
    showTrialEndDate: false,
    description: (t) => t('STATUS_DESC_ENDED'),
    action: { labelKey: 'PAY_NOW', variant: 'contained', handler: 'onPayNow' },
    footer: null,
    sidebarWarning: 'SIDEBAR_WARNING_ENDED',
  },

  [SUBSCRIPTION_STATUS.PAST_DUE]: {
    style: CARD_STYLE.WARNING,
    titleType: 'custom',
    titleKey: 'STATUS_TITLE_PAST_DUE',
    infoLine: (t, sub) => `${sub.renewalInfo} (${t('NEED_TO_PAY')})`,
    showTrialEndDate: false,
    description: (t) => t('STATUS_DESC_PAST_DUE'),
    action: { labelKey: 'PAY_NOW', variant: 'contained', handler: 'onPayNow' },
    footer: 'cancelLink',
    sidebarWarning: 'SIDEBAR_WARNING_PAST_DUE',
  },

  [SUBSCRIPTION_STATUS.UNPAID]: {
    style: CARD_STYLE.ERROR,
    titleType: 'plan',
    infoLine: (t, sub) => `${sub.renewalInfo} (${t('NEED_TO_PAY')})`,
    showTrialEndDate: false,
    description: (t, sub) => `${sub.price} ${sub.period}`,
    action: { labelKey: 'PAY_NOW', variant: 'contained', handler: 'onPayNow' },
    footer: 'cancelLink',
    sidebarWarning: 'SIDEBAR_WARNING_UNPAID',
  },

  [SUBSCRIPTION_STATUS.PAUSED]: {
    style: CARD_STYLE.WARNING,
    titleType: 'custom',
    titleKey: 'STATUS_TITLE_PAUSED',
    infoLine: (t) => t('SUBSCRIPTION_PAUSED'),
    showTrialEndDate: false,
    description: (t) => t('STATUS_DESC_PAUSED'),
    action: { labelKey: 'RESUME', variant: 'contained', handler: 'onResume' },
    footer: null,
    sidebarWarning: 'SIDEBAR_WARNING_PAUSED',
  },

  [SUBSCRIPTION_STATUS.INCOMPLETE]: {
    style: CARD_STYLE.ERROR,
    titleType: 'planWithSubtitle',
    subtitleKey: 'STATUS_SUBTITLE_INCOMPLETE',
    infoLine: (t) => t('PAYMENT_INCOMPLETE'),
    showTrialEndDate: false,
    description: (t) => t('STATUS_DESC_INCOMPLETE'),
    action: { labelKey: 'COMPLETE_PAYMENT', variant: 'contained', handler: 'onCompletePayment' },
    footer: null,
    sidebarWarning: null,
  },

  [SUBSCRIPTION_STATUS.INCOMPLETE_EXPIRED]: {
    style: CARD_STYLE.INACTIVE,
    titleType: 'planWithSubtitle',
    subtitleKey: 'STATUS_SUBTITLE_INCOMPLETE_EXPIRED',
    infoLine: (t) => t('PAYMENT_EXPIRED'),
    showTrialEndDate: false,
    description: (t) => t('STATUS_DESC_INCOMPLETE_EXPIRED'),
    action: { labelKey: 'CHOOSE_PLAN', variant: 'contained', handler: 'onUpgrade' },
    footer: null,
    sidebarWarning: null,
  },
};

export default STATUS_CONFIG;
